
import React from 'react';
import { Coord, Game } from './MarbleSkip';

import './GameBoard.css';

interface GameBoard {
  game: Game | undefined;
  lost: boolean;
  won: boolean;
  moveMarble: (marble:Coord, to:Coord, captured:Coord) => void;
}


function GameBoard(props: GameBoard) {
  const { game, lost, won, moveMarble } = props;
  if (!game) return null;

  const renderRows = () => {
    const rows = [];
    for(let i = 0; i < game.length; i++) {
      const cells = [];
      for(let j = 0; j < game[i].length; j++) {
        const val = game[i][j];
        const key = `board-cell-${j}-${i}`;
        let css = `board-cell value-style-${val}`;

        let text = null;
        if (game[i][j] === 'm') {
          text = 
            <div
              className={'marble'}
              draggable={true}
              onDragStart={(e) => {
                e.dataTransfer.setData( 'text/plain', `${i}-${j}` );
                e.dataTransfer.dropEffect = 'move';
              }}
            ></div>;
        }

        const dropHandler = (e:React.DragEvent<HTMLDivElement>) => {
          const data = e.dataTransfer.getData("text/plain");
          const [di, dj] = data.split('-').map(s => parseInt(s));
          let canDrop = false;
          let captured: Coord;
          let marble: Coord = { i: di, j: dj };
          let to: Coord = {i, j};
          if ((di + 2 === i || di - 2 === i) && dj === j) { 
            if (di + 2 === i) {
              if (game[di+1][j] === 'm') { 
                canDrop = true;
                captured = { i: di + 1, j };
              }
              else { canDrop = false; }
            }
            else {
              if (game[di-1][j] === 'm') { 
                canDrop = true; 
                captured = { i: di - 1, j };
              }
              else { canDrop = false; }
            }
          }
          else if (di === i && (dj + 2 === j || dj - 2 === j)) {
            if (dj + 2 === j) {
              if (game[i][dj + 1] === 'm') { 
                canDrop = true; 
                captured = { i, j: dj + 1 };
              }
              else { canDrop = false; }
            }
            else {
              if (game[i][dj - 1] === 'm') { 
                canDrop = true; 
                captured = { i, j: dj - 1 };
              }
              else { canDrop = false; }
            }
          }
          if (canDrop) {
            // @ts-ignore
            moveMarble(marble, to, captured);
          }
        };

        const cell = 
          <div 
            className={css}
            key={key}
            onDrop={val === 'o' ? dropHandler: undefined}
            onDragOver={val === 'o' ? (e) => {e.preventDefault()}: undefined}
            onDragEnter={val === 'o' ?(e) => {e.preventDefault()}: undefined}
          >
            {text}
          </div>; 
        cells.push(cell)
      }
      const row = <div className="board-row" key={`board-row-${i}`}>{cells}</div>
      rows.push(row);
    }
    return rows;
  };


  return(
    <div className="board">
      {renderRows()}
    </div>
  );
}

export default GameBoard;